<template>
  <a v-if="link"
     :href="link"
     target="_blank"
     class="e-block__product-link"
     :class="additionalClass">
    <slot />
    <span class="e-block__product-link-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 4.5V6.5H16.09L4.5 18.09L5.91 19.5L17.5 7.91V14.5H19.5V4.5H9.5Z" fill="currentColor"/>
      </svg>
    </span>
  </a>
  <div v-else
       @click="click"
       class="e-block__product-link"
       :class="additionalClass">
    <slot />
    <span class="e-block__product-link-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 4.5V6.5H16.09L4.5 18.09L5.91 19.5L17.5 7.91V14.5H19.5V4.5H9.5Z" fill="currentColor"/>
      </svg>
    </span>
  </div>
</template>

<script>

export default {
  name: 'ProductLink',
  props: {
    link: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      availableClasses: ['red'],
    };
  },
  computed: {
    additionalClass() {
      if (this.type && this.availableClasses.indexOf(this.type) > -1) {
        return `e-block__product-link--${this.type}`;
      }
      return '';
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
</style>
